import { type JSX, Match, Switch } from 'solid-js';
import { t } from '../i18n';
import { type ConnectPlan, planCopy } from '../lib/fleet-connect';
import { orgHref } from '../lib/org';
import { OrgUnfundedAlert } from './OrgUnfundedAlert';

// The Connect a machine plan line (#6567), one presenter for both places it is
// said: the dialog shell (before and after a mint) and a refused mint's line in
// either transport (`<EnrollRefusalAlert/>`). Which sentence is `planCopy`'s
// rule (`lib/fleet-connect.ts`); this only lays it out.
//
// The limit sentence is PLAIN copy, not an alert: nothing failed, the plan is the
// limit, and its fix ("See plans") is the billing page. An org at a limit of 0
// gets the named refusal instead, which links billing itself.

export function ConnectPlanLine(props: { readonly plan: ConnectPlan }): JSX.Element {
  return (
    <Switch fallback={<p class="field__desc">{planCopy(props.plan)}</p>}>
      <Match when={props.plan.kind === 'org_unfunded'}>
        <OrgUnfundedAlert />
      </Match>
      <Match when={props.plan.kind === 'at_limit'}>
        {/* `status`: a refused mint lands this line after a click, so it is announced. */}
        <p class="field__desc" role="status">
          {planCopy(props.plan)}{' '}
          <a href={orgHref('/account/billing')}>{t('fleet.connect.see_plans')}</a>
        </p>
      </Match>
    </Switch>
  );
}
